export const WIDTH_BREAKPOINT_LG = '1200px';
export const WIDTH_BREAKPOINT_MD = '992px';
export const WIDTH_BREAKPOINT_SM = '768px';
export const WIDTH_BREAKPOINT_XS = '576px';
